import autoBind from 'react-autobind';
import {connect} from 'react-redux';
import muiThemes from '../../../styles/teamologyTheme';
import Paper from 'material-ui/Paper';
import {setLessonCardDepth} from '../actions';
import {withRouter} from 'react-router';
import {lessonTypeIcons, materialTypeIcons} from '../../shared/constants';
import React, {Component, PropTypes} from 'react';

class LessonPlanCard extends Component {
  constructor(props, context) {
    super(props, context);
    autoBind(this);
  }

  componentDidMount() {
    const {setLessonCardDepth, objectId} = this.props;

    if (objectId) {
      setLessonCardDepth(this.getHoverId(), muiThemes.lessonCardDepths.inactive);
    }
  }

  getHoverId() {
    const {objectId, objectType, gradeText} = this.props;
    return `${objectType}-${gradeText.replace(/\s/g, '-').toLowerCase()}-${objectId}`;
  }

  bindClickHandler(handler) {
    if (!handler) return null;

    const {objectId, objectType, title, gradeText, characterName} = this.props;
    return handler.bind(null, {id: objectId, type: objectType, title, gradeText, characterName});
  }

  handleCardMouseOver() {
    const {setLessonCardDepth} = this.props;
    setLessonCardDepth(this.getHoverId(), muiThemes.lessonCardDepths.active);
  }

  handleCardMouseOut() {
    const {setLessonCardDepth} = this.props;
    setLessonCardDepth(this.getHoverId(), muiThemes.lessonCardDepths.inactive);
  }

  displayGrade(gradeText) {
    const {small} = this.props;
    if (small) return null;

    return <div className="grade">{gradeText}</div>;
  }

  getIcon(displayType, objectType) {
    return objectType === 'lessonPlan'
      ? lessonTypeIcons[displayType.toLowerCase()]
      : materialTypeIcons[displayType.toLowerCase()];
  }

  render() {
    const {
      objectType,
      displayType,
      title,
      gradeText,
      characterName,
      onRequestClick,
      cardDepth,
      small,
    } = this.props;

    const styles = {
      topBarStyle: {
        backgroundColor: muiThemes.characterColors[characterName.toLowerCase()],
      },
    };

    const cardChildren = () =>
      <div className={`lesson-plan-card ${small ? 'small' : ''}`} onClick={this.bindClickHandler(onRequestClick)}>
        { characterName === '' ? <div className="top-bar schoolwide" />
          : <div className="top-bar" style={styles.topBarStyle} />
        }
        <div className="top-info">
          <div>
            {this.getIcon(displayType, objectType)}
            {displayType}
          </div>
          <div>{characterName}</div>
        </div>
        { this.displayGrade(gradeText) }
        <div className="title">{title}</div>
      </div>;

    return (
      <Paper
        zDepth={cardDepth}
        onMouseOver={this.handleCardMouseOver}
        onMouseOut={this.handleCardMouseOut}
        children={cardChildren()} />
    );
  }
}

LessonPlanCard.propTypes = {
  cardDepth: PropTypes.number.isRequired,
  characterName: PropTypes.string,
  displayType: PropTypes.string.isRequired,
  gradeText: PropTypes.string.isRequired,
  objectId: PropTypes.number.isRequired,
  objectType: PropTypes.string.isRequired,
  onRequestClick: PropTypes.func,
  setLessonCardDepth: PropTypes.func.isRequired,
  small: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

function mapStateToProps(state, ownProps) {
  const {showLessonCard} = state.features.shared.pages;
  const {objectId, objectType, gradeText} = ownProps;
  const hoverId = `${objectType}-${gradeText.replace(/\s/g, '-').toLowerCase()}-${objectId}`;

  return {
    cardDepth: showLessonCard.getIn(['cardDepths', hoverId]) ||
                muiThemes.lessonCardDepths.inactive,
  };
}

export default withRouter(connect(
  mapStateToProps,
  {
    setLessonCardDepth,
  }
)(LessonPlanCard));



// WEBPACK FOOTER //
// ./app/features/shared/components/LessonPlanCard.js